import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Router basename="/nethram">
        <Routes>
          <Route path="/:id" element={<Home />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
